import { render, staticRenderFns } from "./problems.vue?vue&type=template&id=68d82570&scoped=true&"
import script from "./problems.vue?vue&type=script&lang=js&"
export * from "./problems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d82570",
  null
  
)

export default component.exports